define('Components/Comein/js/Comein',['hooks','jquery','app',
    'Components/Comein/js/views/pages/ComeinPageView',
    'Components/Comein/js/views/blocks/ComeinProfileAdvantagesView',
    'Components/Comein/js/views/blocks/ComeinLoyaltyHistoryView',
    'Components/Comein/js/views/pages/AuthentificationComeinPageView',
    'Components/Comein/js/views/blocks/CartDeliveryDataView',
    'template!Components/Comein/templates/blocks/header-navigation',
    'template!Components/Comein/templates/blocks/customer-comeIn-icon',
    'Components/Comein/js/views/blocks/AutocompleteFilterButtonExtensionView'
],function(hooks,$,app,
           ComeinPageView,
           ComeinProfileAdvantagesView,
           ComeinLoyaltyHistoryView,
           AuthentificationComeinPageView,
           CartDeliveryDataView,
           HeaderNavigationTemplate,
           CustomerComeInIconTemplate,
           AutocompleteFilterButtonExtensionView
){

    //
    // Comein Component
    //

    return function() {

        var registerHook = hooks.registerHook; // func alias

        registerHook('PageFactory', function (pageName, callback) {
            switch (pageName) {
                case 'AuthentificationComein' :
                    callback.call(null, AuthentificationComeinPageView);
                    break;
                case 'ComeinController' :
                    console.log(pageName);
                    callback.call(null, ComeinPageView);
                    break;
                case 'ComeinHistoryController' :
                    callback.call(null, ComeinLoyaltyHistoryView);
                    break;
            }
        });

        registerHook('NavExtraData', function (options, callback) {
            var customer = app.getCustomer();
            callback.call(null, t("Numeros: ", 'Account') + ' <span>' + customer.getNeolaneParam('account','') + '</span>');
        });

        registerHook('useCagnotte',function(cart, callback){
            var store = cart.getStore();
            callback.call(null, !!store && store.get('is_comein'));
        })

        registerHook('IsComeinEnable', function (options, callback) {
            callback.call(null, true);
        });

        registerHook('LoyaltyHistoryView', function (options, callback) {
            callback.call(null, ComeinLoyaltyHistoryView);
        });

        registerHook('LoyaltyProfileView', function (options, callback) {
            callback.call(null, ComeinProfileAdvantagesView);
        });

        registerHook('getAuthentificationComeinPageView', function(options,callback){
            callback.call(null, AuthentificationComeinPageView);
        })

        registerHook('HeaderNavigation', function(options, callback){
            var html = app.getCustomer().isLogged() ? null : HeaderNavigationTemplate()
            callback.call(null, html);
        })

        registerHook('AutocompleteFilterButtonExtensionView', function(options,callback){
            if (app.c('_COMEIN_TOOLTIP_ON_AUTOCOMPLETE_', 1) == 1 ) {
                callback.call(null,AutocompleteFilterButtonExtensionView);
            }
        })

        registerHook('hookCheckoutCagnottageDataView', function(options){
            options.view.appendView(CartDeliveryDataView,options.selector,_.pick(options,['cart','context']));
        })

        registerHook('CustomerComeInIcon', function(cart, callback){
            callback.call(null, CustomerComeInIconTemplate());
        })

        registerHook('getFidelityComponentTheme', function(options, callback){
            callback.call(null, 'theme-comein');
        })
    }
});
